import * as React from "react"
import { Action, mk_widget, Widget } from "widgets-for-react"
import {  LoginState, isChooseRoleState, ChooseRoleState } from "../state"
import { notifications } from '../notifications';
import { MinimalLoginWidgetData } from "../login";
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";

function handleSubmit<a, extra_user_info>(e:React.FormEvent<HTMLFormElement>, setState:(_: Action<LoginState<a, extra_user_info>>) => void) {
  e.preventDefault();
  setState(s => isChooseRoleState(s) ? ({...s, status:"choose role - logging in"}) : s);
}

export function choose_roles_form<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) { 
  return (s0:ChooseRoleState, readonly: boolean) : Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-choose-roles-form">
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "mb-4")}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>Select role</h1>
                <p className={getClassName(options, "intro_classname", "lead")}></p>
              </header>
    
              <form onSubmit={(e) => handleSubmit(e, setState)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  {notifications(s0, { style: LoginFlowClasses }).run(() => s => s)}
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="role_select"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Role
                    </label>
                    <div className={getClassName(options, "form_select_classname", "")}>
                      <select
                        name="role_select"
                        id="role_select"
                        value={s0.login_data.role}
                        disabled={readonly}
                        className={getClassName(options, "form_input_classname", "form-control")}
                        onChange={(event) => setState(s => isChooseRoleState(s) ? ({
                          ...s,
                          status:"choose role",
                          login_data: {
                            ...s.login_data,
                            role: event.currentTarget.value }
                          }) : s)}
                        >
                          {!s0.login_data.role ? <option value={""}>Select a role</option> : null}
                          {s0.login_data.roles.map(role => (
                            <option value={role}>{role}</option>
                          ))}
                        </select>
                    </div>
                  </div>
  
                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      disabled={readonly}
                    >
                      {s0.login_data.role ? `Continue as ${s0.login_data.role}` : "Continue"}
                    </button>
    
                    <button
                      type="button"
                      className={getClassName(options, "clickable_secondary_classname", "btn btn-link ml-3")}
                      disabled={readonly}
                      onClick={(event) => setState(s => isChooseRoleState(s) ? ({
                        status:"logged out",
                        login_data: {
                          username: s.login_data.username,
                          password: s.login_data.password,
                          show_password: false }
                        }) : s)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}
